import { StatisticsWidgetProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: StatisticsWidgetProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as StatisticsWidgetProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      props: {
        items: [
          {
            value: '$7,500',
            description: 'Monday',
            percentage: 21,
            invertedPercentage: true,
          },
          {
            value: '1 200 000',
            description: 'Tuesday',
            descriptionInfo: 'Sales on Tuesday',
            percentage: 11,
          },
          {
            value: '21k',
            description: 'Wednesday',
          },
        ],
      },
    } as StatisticsWidgetProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
